export default __webpack_public_path__ + "static/integration-da5b2ed6c7e808d782a9921a57ffff29.webp";